import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel, Checkbox as MUICheckbox } from "@mui/material";
export default function Checkbox(props) {
    const { loopArray, field } = props;
    field.value = field.value ? field.value : [];
    return (_jsx("div", Object.assign({ style: { margin: '8px 0px' } }, { children: loopArray.map((item) => (_jsx(FormControlLabel, { label: item.charAt(0).toUpperCase() + item.slice(1), sx: { gap: '4px', marginRight: '40px' }, control: _jsx(MUICheckbox, { value: item, checked: field.value.includes(item), sx: { color: '#4E3BC9' }, onChange: (event, checked) => {
                    if (checked) {
                        field.onChange([...field.value, event.target.value]);
                    }
                    else {
                        field.onChange(field.value.filter((value) => value !== event.target.value));
                    }
                } }) }, item))) })));
}
